export const CREATING = 'creating'
export const CREATED = 'created'
export const UPDATING = 'updating'
export const UPDATED = 'updated'
export const DELETING = 'deleting'
export const DELETED = 'deleted'
export const RESTORING = 'restoring'
export const RESTORED = 'restored'
